// extracted by mini-css-extract-plugin
export default {"contextMenu":"ContextMenu__contextMenu___lzy7f"};